module.exports = __webpack_public_path__ + "static/media/rickandmorty1.23089153.png";